import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BenefitsComponent } from '../../components/benefits/benefits.component';
import { BuyNowButtonComponent } from '../../components/buy-now-button/buy-now-button.component';
import { GalleryComponent } from '../../components/gallery/gallery.component';

interface Ingredient {
  name: string;
  image: string;
}

@Component({
  selector: 'app-home',
  standalone: true,
  imports: [
    CommonModule,
    BuyNowButtonComponent,
    BenefitsComponent,
    GalleryComponent
],
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent {
  products: any[] = [];

  tummyDetoxIngredients: Ingredient[] = [
    { name: 'Yashtimadhu', image: 'assets/images/yashtimadhu.png' },
    { name: 'Senna', image: 'assets/images/senna.png' },
    { name: 'Saunf', image: 'assets/images/saunf.png' },
    { name: 'Rose', image: 'assets/images/rose.png' },
    { name: 'Haritaki', image: 'assets/images/haritaki.png' },
    { name: 'Ajowain', image: 'assets/images/ajowain.png' }
  ];

  madhuDetoxIngredients: Ingredient[] = [
    { name: 'TejPatta', image: 'assets/images/tejpatta.png' },
    { name: 'Methi', image: 'assets/images/methi.png' },
    { name: 'Meshasringi', image: 'assets/images/meshasringi.png' },
    { name: 'Kadi-patta', image: 'assets/images/kadi-patta.png' },
    { name: 'Jamun', image: 'assets/images/jamun.png' },
    { name: 'Bilva', image: 'assets/images/bilva.png' }
  ];
}
